import {
  WEBSOCKET_EVENT_ERROR,
  WEBSOCKET_EVENT_SUCCESS,
  type VoiceMessageWebsocketEvent,
} from "@circle-react/components/shared/uikit/TipTap/VoiceMessage/constants";
import { usePunditUserContext } from "@circle-react/contexts/punditUserContext";
import type { Editor } from "@tiptap/core";

import { useNotificationWebSocket } from "@/react/hooks/notifications/useNotificationWebSocket";

interface UseBlockEditorWebsocketProps {
  addToLocalInlineAttachments: (attachment: any) => void;
  editor: Editor;
  onClose: () => void;
  range: { from: number; to: number };
  recordingId: string;
  setServerError: () => void;
}

export const useBlockEditorWebsocket = ({
  onClose,
  recordingId,
  setServerError,
  addToLocalInlineAttachments,
  editor,
  range,
}: UseBlockEditorWebsocketProps) => {
  const { currentCommunityMember } = usePunditUserContext();
  const { id: currentCommunityMemberId = 0 } = currentCommunityMember || {};

  useNotificationWebSocket(
    currentCommunityMemberId,
    (eventData: VoiceMessageWebsocketEvent) => {
      if (
        (eventData.event === WEBSOCKET_EVENT_SUCCESS ||
          eventData.event === WEBSOCKET_EVENT_ERROR) &&
        eventData.json_message.recording_id === recordingId
      ) {
        if (eventData.event === WEBSOCKET_EVENT_SUCCESS) {
          addToLocalInlineAttachments({
            url: eventData.json_message.url,
            signed_id: eventData.json_message.signed_id,
            content_type: eventData.json_message.content_type,
            metadata: { voice_message: true },
          });

          editor
            .chain()
            .focus()
            .deleteRange(range)
            .insertContent({
              type: "file",
              attrs: {
                signed_id: eventData.json_message.signed_id,
              },
            })
            .run();

          onClose();
        } else if (eventData.event === WEBSOCKET_EVENT_ERROR) {
          setServerError();
        }
      }
    },
  );
};
